import * as React from 'react';
import './RefereePageLayout.less';
import FlowLayout, { FlowLayoutProps } from './FlowLayout';
import Footer from './footer/Footer';

const RefereePageLayout = (props: Props) => {
	// Instead of passing through children direct to FlowLayoutProps, this component wraps them first.
	const { className, children, ...otherFlowLayoutProps } = props;
	const refereeQuestionsRequired = props.refereeQuestionsRequired ?? true;
	if (!children) return null;

	const flowProgressBarNames = refereeQuestionsRequired ? ['Validation', 'Questions', 'Review'] : ['Validation'];

	const navigateToPageUsingFlowProgressName = (flowProgressBarName: string) => {
		props.navigateToPage(flowProgressBarName?.toLowerCase());
	};

	return (
		<section className={`refereePage ${className}`}>
			<FlowLayout
				// eslint-disable-next-line react/jsx-props-no-spreading
				{...otherFlowLayoutProps}
				flowProgressBarNames={flowProgressBarNames}
				navigateToPage={props.navigateToPage && navigateToPageUsingFlowProgressName}
			>
				<section className="pageBody">{children}</section>
			</FlowLayout>
			<Footer />
		</section>
	);
};

interface Props extends FlowLayoutProps {
	navigateToPage?: (slug: string) => void;
	className?: string;
	refereeQuestionsRequired?: boolean;
}

RefereePageLayout.defaultProps = {
	navigateToPage: null,
	className: null,
	refereeQuestionsRequired: true
};

export default RefereePageLayout;
